import React from 'react';
import './AppMenu.scss';

interface AppMenuProps {
  description: string;
  img: string;
  name: string;
  price: string;
}

export const AppMenu: React.FC<AppMenuProps> = (props) => {
  const showDescription = props.description !== null && props.description !== '';
  return (
    <div className='app-menu'>
      <img src={props.img} className='w-100' />
      <div className='app-menu-content'>
        <div className='app-menu-heading'>
          <h3 className='app-menu-name'>{props.name}</h3>
          <p className='app-menu-price'>${props.price}</p>
        </div>
        {showDescription && <p className='app-menu-description'>{props.description}</p>}
      </div>
    </div>
  );
};
